import { defaultSalesHeaderDto, SalesHeaderDto } from "src/dtos/sales/salesBillDto";
import { formatDate } from "src/utils/string/stringUtil";

/**
 * SAL2030_R01 - 영업 매출 내역 조회 DTO
 */
export interface SAL2030_R01Dto extends SalesHeaderDto {
	rowKey: string;
}

export const createSAL2030_R01RowKey = (compCd?: string, salesDt?: string) => {
	return `${compCd || ''}_${salesDt ? formatDate(salesDt) : ''}`;
};

/** API BigDecimal 객체({ source, parsedValue }) 또는 number/string을 숫자로 변환 */
export const parseSAL2030_R01Amt = (value: unknown): number => {
	if (value == null || value === '') return 0;
	if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
	if (typeof value === 'string') {
		const parsed = Number(value.replace(/,/g, ''));
		return Number.isFinite(parsed) ? parsed : 0;
	}
	if (typeof value === 'object') {
		const record = value as { parsedValue?: unknown; source?: unknown };
		if (record.parsedValue != null) return parseSAL2030_R01Amt(record.parsedValue);
		if (record.source != null) return parseSAL2030_R01Amt(record.source);
	}
	return 0;
};

/**
 * 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2030_R01Dto: SAL2030_R01Dto = {
	...defaultSalesHeaderDto,
	rowKey: '',
};
